<template>
  <div class="container-fluid">
    <h3 class="mb-4">Invoice Rawat Inap</h3>
    <DetailTop v-if="detailTop" :detailTop="detailTop" />
    <div class="row">
      <div class="col-md-12">
        <div
          class="d-flex flex-between my-3"
          v-if="dataTagihan && dataTagihan.length"
        >
          <div class><h5 class="mb-0">Tagihan Kamar Inap</h5></div>
        </div>
        <table class="responsive" v-if="dataTagihan && dataTagihan.length">
          <thead>
            <th>TANGGAL</th>
            <th>NAMA KAMAR</th>
            <th>NO. KASUR</th>
            <th>KELAS</th>
            <th>TARIF/BIAYA</th>
          </thead>
          <tbody>
            <tr v-for="item in dataTagihan" v-bind:key="item.id">
              <td>{{ item.formatted_tgl }}</td>
              <td>{{ `${item.kamar_ranap.nama}` }}</td>
              <td>{{ item.kamar_ranap.formatted_no_kasur }}</td>
              <td>{{ `${item.kamar_ranap.formatted_kelas}` }}</td>
              <td>
                {{ item.formatted_biaya }}
                <router-link
                  class="btn btn-icon btn-primary btn-sm mr-2 ml-3"
                  :to="
                    `/ranap/form-tagihan/${$route.params.id}/edit/${item.id}`
                  "
                >
                  <i class="material-symbols-outlined">create</i>
                </router-link>
                <!-- <button class="btn btn-icon btn-danger btn-sm">
                <i class="material-symbols-outlined">delete</i>
              </button> -->
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3"></td>
              <td>
                <h4 class="my-2">Total Tagihan</h4>
              </td>
              <td>
                <h4 class="my-2 pr-4 mr-4">
                  {{ convertToRupiah(totalTagihan) }}
                </h4>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="position: relative">
        <div class="d-flex flex-between mt-4 mb-3" v-if="doc && doc.length">
          <h5 class="mb-2">Penanganan oleh Dokter</h5>
        </div>
        <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'doc')" v-if="s_doc && a_doc" :loading="l_doc" :data="r_doc" /> -->

        <table v-if="doc && doc.length" class="responsive">
          <thead>
            <th>KODE</th>
            <th>NAMA PERAWATAN</th>
            <th>KATEGORI PERAWATAN</th>
            <th>TARIF/BIAYA</th>
          </thead>
          <tbody>
            <tr v-for="item in doc" v-bind:key="item.id + Math.random(1024)">
              <td>{{ item.tindakan.kode }}</td>
              <td>{{ item.tindakan.nama }}</td>
              <td>{{ item.tindakan.kategori }}</td>
              <td>{{ item.tindakan.formatted_biaya }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2"></td>
              <td>
                <h4 class="my-2">Total Biaya Penanganan Dokter</h4>
              </td>
              <td colspan="1" class="text-right">
                <h4 class="my-2">{{ convertToRupiah(doc_count) }}</h4>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="d-flex flex-between mt-4 mb-3" v-if="nrs && nrs.length">
          <h5 class="mb-2">Penanganan oleh Petugas</h5>
        </div>
        <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'nrs')" v-if="s_nrs && a_nrs" :loading="l_nrs" :data="r_nrs" /> -->
        <table class="responsive" v-if="nrs && nrs.length">
          <thead>
            <th>KODE</th>
            <th>NAMA PERAWATAN</th>
            <th>KATEGORI PERAWATAN</th>
            <th>TARIF/BIAYA</th>
          </thead>
          <tbody>
            <tr v-for="item in nrs" v-bind:key="item.id + Math.random(1024)">
              <td>{{ item.tindakan.kode }}</td>
              <td>{{ item.tindakan.nama }}</td>
              <td>{{ item.tindakan.kategori }}</td>
              <td>{{ item.tindakan.formatted_biaya }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2"></td>
              <td>
                <h4 class="my-2">Total Biaya Penanganan Petugas</h4>
              </td>
              <td colspan="1" class="text-right">
                <h4 class="my-2">{{ convertToRupiah(nrs_count) }}</h4>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="d-flex flex-between mt-4 mb-3" v-if="both && both.length">
          <h5 class="mb-2">Penanganan oleh Dokter dan Petugas</h5>
        </div>
        <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'both')" v-if="s_both && a_both" :loading="l_both" :data="r_both" /> -->
        <table class="responsive" v-if="both && both.length">
          <thead>
            <th>KODE</th>
            <th>NAMA PERAWATAN</th>
            <th>KATEGORI PERAWATAN</th>
            <th>TARIF/BIAYA</th>
          </thead>
          <tbody>
            <tr v-for="item in both" v-bind:key="item.id + Math.random(1024)">
              <td>{{ item.tindakan.kode }}</td>
              <td>{{ item.tindakan.nama }}</td>
              <td>{{ item.tindakan.kategori }}</td>
              <td>{{ item.tindakan.formatted_biaya }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2"></td>
              <td>
                <h4 class="my-2">Total Biaya Penanganan Dokter dan Petugas</h4>
              </td>
              <td colspan="1" class="text-right">
                <h4 class="my-2">{{ convertToRupiah(both_count) }}</h4>
              </td>
            </tr>
          </tfoot>
        </table>
        <hr />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-6">
        <h4 class="mb-4">Ringkasan</h4>
        <div class="card px-4 py-3 my-2" v-if="ringkasan">
          <div class="row">
            <div class="col-md-12">
              <div class="row mb-4">
                <div class="col-md-6">
                  <span
                    :class="
                      `badge badge-${
                        ringkasan.status == 'BELUM DIBAYAR'
                          ? 'danger'
                          : ringkasan.status == 'BELUM LUNAS'
                          ? 'warning'
                          : 'primary'
                      }`
                    "
                    >{{ ringkasan.status }}</span
                  >
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Nomor Pembayaran</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0">
                    {{ ringkasan ? ringkasan.no_pembayaran : "" }}
                  </h4>
                </div>
              </div>
              <hr />
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Total Pembayaran</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0">
                    {{
                      ringkasan
                        ? convertToRupiah(ringkasan.total_bayar)
                        : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-3" v-if="ringkasan.ditanggung">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Ditanggung</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="">
                    {{
                      ringkasan ? convertToRupiah(ringkasan.ditanggung) : "Rp 0"
                    }}
                  </h4>
                  <h5 class="text-secondary">
                    Ditanggung oleh {{ asuransi[id_asuransi] }}
                  </h5>
                  <!-- <div class="card p-2 my-3" style="background:#7f8f9">
                    <p class="mb-1">Ditanggung oleh {{asuransi[id_asuransi]}}</p>
                    <h5 class="mb-0">Ditanggung oleh {{asuransi[id_asuransi]}}</h5>
                </div> -->
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Yang harus dibayar</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0 text-info">
                    {{
                      ringkasan
                        ? convertToRupiah(
                            ringkasan.total_bayar - ringkasan.ditanggung
                          )
                        : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Telah dibayar</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="text-primary">
                    {{
                      ringkasan ? convertToRupiah(ringkasan.dibayar) : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Sisa bayar</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0 text-danger">
                    {{
                      ringkasan
                        ? convertToRupiah(ringkasan.sisa_tagihan)
                        : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loading v-else />
      </div>
      <div class="col-md-6">
        <h4 class="mb-4">Riwayat Pembayaran</h4>
        <b-row v-if="ringkasan && riwayat">
          <b-col md="12">
            <table class="responsive">
              <thead v-if="riwayat && riwayat.length">
                <th>TANGGAL</th>
                <th>JAM</th>
                <th>CARA BAYAR</th>
                <th>JUMLAH PEMBAYARAN</th>
              </thead>
              <tbody v-if="riwayat && riwayat.length">
                <tr
                  v-for="item in riwayat"
                  v-bind:key="item.id + Math.random(1024)"
                >
                  <td>{{ item.formatted_tanggal }}</td>
                  <td>{{ item.formatted_jam }}</td>
                  <td>
                    {{ item.cara_bayar
                    }}{{ item.no_kartu ? " - " + item.no_kartu : "" }}
                  </td>
                  <td>{{ item.formatted_jumlah }}</td>
                </tr>
              </tbody>
              <tfoot v-if="riwayat && riwayat.length">
                <tr>
                  <td colspan="2"></td>
                  <td>
                    <h4 class="my-2">SISA PEMBAYARAN</h4>
                  </td>
                  <td colspan="1" class="text-right">
                    <h4 class="mt-2 mb-2">
                      {{
                        ringkasan
                          ? convertToRupiah(ringkasan.sisa_tagihan)
                          : "Rp 0"
                      }}
                    </h4>
                  </td>
                </tr>
              </tfoot>
              <tfoot v-else>
                <tr>
                  <td style="padding-left: 0 !important">
                    <p>Belum ada Riwayat Pembayaran di sini</p>
                  </td>
                  <td colspan="1" class="text-right"></td>
                </tr>
              </tfoot>
            </table>
          </b-col>
        </b-row>
        <Loading v-else />
      </div>
    </div>

    <!--/form-->
  </div>
</template>

<script>
// @ is an alias to /src
// import Alert from '@/components/Alert.vue'
// import SearchResult from '@/components/SearchResult.vue'
// import Navbar from '@/components/Navbar.vue'
// import Sidebar from '@/components/Sidebar.vue'
// import FormRow from '@/components/FormRow.vue'
import DetailTop from "@/components/DetailTop.vue";
// import DetailLeft from '@/components/DetailLeft.vue'
// import DetailRight from '@/components/DetailRight.vue'
import Loading from "@/components/Loading.vue";
// import FormData from "form-data";
import { setBayarIntro, convertToRupiah } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { data, jumlahForm, bayarForm } from "@/data/KasirForm.js";

export default {
  name: "KasirInvoiceRanap",
  components: {
    DetailTop,
    Loading,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      dataTagihan: [],
      id_asuransi: null,
      id_ralan: "",
      no_rawat: "",
      lunas: false,
      visible: false,
      tab: "rincian",
      data: data,
      convertToRupiah: convertToRupiah,
      history: [],
      asuransi: { 1: "Umum", 2: "BPJS", 3: "Asuransi" },
      jumlahForm: jumlahForm,
      bayarForm: bayarForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        id_tagihan_ringkasan: "",
        jumlah: "",
        cara_bayar: "",
        no_kartu: "",
        lunas: [],
      },
      n: 0,
      lab: [],
      doc: [],
      nrs: [],
      both: [],
      lab_count: 0,
      doc_count: 0,
      nrs_count: 0,
      both_count: 0,
      isError: false,
      ringkasan: null,
      riwayat: null,
    };
  },
  methods: {
    fetchRingkasan: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          this.no_rawat = result.data.no_rawat;
          this.ringkasan = result.data;
          let resultRalan = await this.$store.state.HTTP.get(
            `ralan/${this.id_ralan}`
          );
          this.id_asuransi = resultRalan?.data?.id_asuransi;
          //console.log(resultRalan);
          this.detailTop = setBayarIntro(resultRalan.data);
          let resultTindakan = await this.$store.state.HTTP.get(
            `ranap/tindakan/penanganan?no_rawat=${resultRalan.data.no_rawat}`
          );
          if (resultTindakan.status == 200) {
            //console.log(resultTindakan);
            let that = this;
            this.doc = resultTindakan.data.penanganan_dokter;
            this.both = resultTindakan.data.penanganan_dokter_petugas;
            this.nrs = resultTindakan.data.penanganan_petugas;
            // this.doc_count=this.ringkasan.formatted_sub_total_dok;
            // this.nrs_count=this.ringkasan.formatted_sub_total_ptg;
            // this.both_count=this.ringkasan.formatted_sub_total_dp;
            that.doc_count = 0;
            that.nrs_count = 0;
            that.both_count = 0;
            this.doc.forEach((item) => {
              //console.log(item);
              that.doc_count += item.biaya;
            });
            this.nrs.forEach((item) => {
              //console.log(item);
              that.nrs_count += item.biaya;
            });
            this.both.forEach((item) => {
              //console.log(item);
              that.both_count += item.biaya;
            });
          }
          this.fetchTagihanKamar();
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchTagihanKamar: async function() {
      let res = await this.$store.state.HTTP.get(
        `ranap?no_rawat=${this.no_rawat}`
      );
      let self = this;
      //console.log(res);
      if (res && res.data.data.length) {
        try {
          let result = await this.$store.state.HTTP.get(
            `/ranap/tagihan/kamar?id_ranap=${res.data.data[0].id}`
          );
          //console.log(result);
          if (result.status == "200") {
            //console.log(result);
            this.totalTagihan = 0;
            this.dataTagihan = result.data.data.map((item) => {
              self.totalTagihan += item.biaya;
              return item;
            });
            this.print();
            //console.log(this.dataTagihan);
          } else {
            //console.log(result.status);
          }
        } catch (e) {
          //console.log(e);
          // this.errors.push(e);
          // this.saveFailed=true;
        }
      }
    },
    fetchRiwayat: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_pembayaran?id_tagihan_ringkasan=${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result);
          this.riwayat = result.data.data;
          this.print();
          //console.log(this.riwayat);
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    init: async function() {
      this.tab = this.$route.params.tab;
      this.formSet.id_tagihan_ringkasan = this.$route.params.id;
      this.fetchRingkasan();
      this.fetchRiwayat();
    },
    print: async function() {
      if (this.ringkasan && this.riwayat)
        setTimeout(function() {
          window.print();
        }, 2000);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.init();
  },
};
</script>
